<template>
    <div id="productLog">
        <p class="title-txt">平台日志</p>
        <!-- 列表 -->
        <div class="list-box">
            <div class="bg">
                <div class="search-box">
                    <div style="margin-bottom: 12px;">
                        级别：
                        <el-select v-model="functionId" placeholder="请选择" class="m-l-5">
                            <el-option :value='null' label="全部模块"></el-option>
                            <el-option v-for="func in functionList" :key="func.id" :value="func.id" :label="func.name"></el-option>
                        </el-select>
                    </div>
                    <div style="margin-bottom: 12px;">
                        时间：
                        <el-date-picker
                            v-model="beginDate"
                            :editable="false"
                            type="date"
                            class="time m-r-12 m-l-5"
                            placeholder="选择日期"
                            :picker-options="pickerOptionsStart"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                        <span class="m-r-12">至</span>
                        <el-date-picker
                            v-model="endDate"
                            :editable="false"
                            type="date"
                            class="time"
                            placeholder="选择日期"
                            :picker-options="pickerOptionsEnd"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </div>
                    <div>
                        关键字：<el-input v-model="keyword" placeholder="请输入详情关键字" class="m-l-5 w-200" @keyup.enter.native="search"></el-input>
                    </div>
                    <el-button type="primary" @click="search">搜索</el-button>
                    <a :href="exportLogUrl" id="exportLog" class="exportLog-btn" @click="exportLog">导出</a>
                </div>
                <div class="company-list clearfix">
                    <ul class="list-title" style="position: relative; top: 25px; width: 97.6%;">
                        <li class="w-18">类型</li>
                        <li>级别</li>
                        <li class="w-18">时间</li>
                        <li class="w-50">内容</li>
                    </ul>
                    <div class="scroll">
                        <ul class="list-details" v-for="(item,i) in dataList" :key="i" v-show="dataList.length!=0">
                            <li :title="''" class="w-18">{{item.type}}</li>
                            <li :title="item.level==1?'提示':item.level==2?'警告':item.level==3?'故障':''">{{item.level==1?'提示':item.level==2?'警告':item.level==3?'故障':''}}</li>
                            <li :title="changeTime(item.createdTime)" class="w-18">{{changeTime(item.createdTime)}}</li>
                            <li :title="item.content" class="w-50">{{item.content}}</li>
                        </ul>
                    </div>
                </div>
                <!-- 没有列表数据 -->
                <div class="nullDataBox" v-show="dataList.length==0">
                    <img :src="nullData" class="nullData">
                    <span>什么东西都没有找到...</span>
                </div>
            </div>
            <!-- 分页 -->
            <Pagination @setSize="setSize" @setNum="setNum" :totalCount="totalCount" :setNumber="pageNumber"></Pagination>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/PublicAssembly/pagination"
export default {
    data() {
        return {
            nullData:require('@/assets/image/index/nullData.png'),
            totalCount:1,
            pageSize:10,
            pageNumber:1,
            dataList:[],
            state:0,
            functionId:'',
            beginDate:'',
            userName:'',
            ip:'',
            endDate:'',
            keyword:'',
            functionList:[{name:'企业管理',id:1},
                {name:'用户管理',id:2},
                {name:'角色管理',id:3},
                {name:'组织管理',id:4},
                {name:'运维大屏',id:5},
                {name:'产品管理',id:6},
                {name:'企业运维',id:7},
                {name:'通知规则',id:8},
                {name:'数据集',id:10},
                {name:'平台设置',id:11}],
            pickerOptionsStart: {
                disabledDate: time => {
                    if (this.endTime) {
                        return time.getTime() > new Date(this.endTime).getTime()
                    }
                }
            },
            pickerOptionsEnd: {
                disabledDate: time => {
                    if (this.beginDate) {
                        return time.getTime() < new Date(this.beginDate).getTime() - 86400000
                    }
                }
            },
            exportLogUrl:''
        }
    },
    components:{
        Pagination,
    },
    created() {
        this.$store.state.activeIndex='/productLog'
        this.pageSize=this.$store.state.userConfig.rowsPerPage;
        this.getlist({pageNumber:1,length:Number(this.pageSize)});
        // this.getFunction()
        this.exportLog()
    },
    methods: {
        // 获取模块
        getFunction(){
            this.get('/Function/getList',{type:1}).then((res)=>{
                if(res.success){
                    let i = 1
                    for(let obj of res.result){
                       if(obj.type==1){
                            obj.id = i
                            this.functionList.push(obj)
                            i++
                       }
                    }
                }else{
                    this.$message({
                        type:'warning',
                        message:`获取模块数据失败：${res.message}`
                    })
                }
            })
        },
        // 获取列表
        getlist(parm){
            this.get('/Log/querySystemLog',parm).then((res)=>{
                if(res.success){
                    this.dataList=res.result.data
                    this.totalCount = res.result.totalCount
                }else{
                    this.$message({
                        message: `获取列表数据失败：${res.productLog}`,
                        type: 'warning'
                    });
                }
            })
        },
        // 修改分页size
        setSize(pageObj){
            this.pageSize=pageObj.size;
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                userName:this.userName,
                ip:this.ip,
                functionId:this.functionId,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.keyword
            }
            this.getlist(parm)
        },
        // 修改页数
        setNum(number){
            this.pageNumber=number;
            let parm={
                pageNumber:this.pageNumber,
                length:this.pageSize,
                userName:this.userName,
                ip:this.ip,
                functionId:this.functionId,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.keyword
            }
            this.getlist(parm)
        },
        // 搜索
        search(){
            this.pageNumber = 1
            let parm={
                pageNumber:1,
                length:this.pageSize,
                userName:this.userName,
                ip:this.ip,
                functionId:this.functionId,
                beginDate:this.beginDate==''||this.beginDate==null?null:new Date(this.beginDate+' 00:00:00').getTime().toString(),
                endDate:this.endDate==''||this.endDate==null?null:new Date(this.endDate+' 23:59:59').getTime().toString(),
                keyword:this.keyword
            }
            this.getlist(parm)
        },
        // 导出日志
        exportLog(){
            let beginDate=this.beginDate==''||this.beginDate==null?'':new Date(this.beginDate+' 00:00:00').getTime().toString()
            let endDate=this.endDate==''||this.endDate==null?'':new Date(this.endDate+' 23:59:59').getTime().toString()
            let url = window.location.protocol + '//' + window.location.host
            url += `/api/v1/Log/exportSystemLog?keyword=${this.keyword}&userName=${this.userName}&ip=${this.ip}&functionId=${this.functionId}&beginDate=${beginDate}&endDate=${endDate}&requestId=0`
            this.exportLogUrl = url
        }
    },
}
</script>
<style scoped>
    .title-txt{
        text-align: left;
        font-size: 16px;
        padding-left: 16px;
    }
    .type-box{
        background-color: #fff;
        width: 216px;
        position: absolute;
        top: 32px;
        left:16px;
        bottom: 0;
        padding: 0 12px;
        box-sizing: border-box;
    }
    .type-box p{
        line-height: 48px;
        font-size: 14px;
        border-bottom: 1px solid #e5e5e5;
    }
    .tabs-box{
        float: left;
        height: 40px;
        overflow: hidden;
        background-color: #fff;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border: 1px solid #d2d2d2;
    }
    .tabs-box div{
        float: left;
        padding: 9px 0;
    }
    .tabs-box span{
        display: inline-block;
        width: 110px;
        font-size: 14px;
        line-height: 22px;
        border-left: 1px solid #e2e2e2;
        cursor:pointer;
        float: left;
    }
    .tabs-box>div:first-child span{
        border: none;
    }
    .list-box{
        position: absolute;
        top: 40px;
        left: 16px;
        right: 0;
        bottom: 0;
    }
    .list-top{
        margin: 0px 16px 15px 16px;
        padding-top: 24px;
        height: 34px;
    }
    .add-btn{
        float: left;
        line-height: 32px !important;
        padding: 0 15px !important;
    }
    .search{
        float: right;
        width: 388px;
        margin-right: 10px;
    }
    .search-btn{
        float: right;
    }
    .company-list{
        overflow: hidden;
        height: 91%;
    }
    .scroll{
        overflow: auto;
        width: 97.6%;
        height: calc(100% - 140px);
        max-height: calc(100% - 140px) !important;
        margin: 0 16px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        margin-top: 24px;
    }
    /* .scroll>ul:last-child{
        border-bottom: 0;
    } */
    .list-title,.list-details{
        display: flex;
        justify-content: space-around;
        line-height: 44px;
        font-size: 14px;
        color: #636363;
    }
    .list-title{
        background: #eeeeee;
    }
    .list-title li,.list-details li{
        width: 200px;
        margin: 0 20px;
        text-align: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .list-details{
        border-top:1px solid #f2f2f2;
    }
    .operate span{
        margin: 0 4px;
        color: #5087e4;
    }
    .w-18{
        width: 18% !important;
    }
    .w-50{
        width: 50% !important;
    }
    .list-details:last-child{
        border-bottom:1px solid #f2f2f2;
    }
    img.notes{
        position: relative;
        left: 5px;
        top: 5px;
    }
    .w-90{
        width: 90px !important;
        margin-right: 40px !important;
    }
    .active{
        background: #5087e4;
        color: #fff;
    }
    .active>span{
        border: 0;
    }
    .bg{
        width: 100%;
        height: calc(100% - 60px);
    }

    .search-box{
        text-align: left;
        padding: 22px 20px 0 20px;
        font-size: 14px;
    }
    .search-box div{
        display: inline-block;
        margin-right: 16px;
    }
    .w-200{
        width: 190px !important;
    }
    .m-l-5{
        margin-left: 5px !important;
    }
    .m-r-12{
        margin-right: 12px !important;
    }
</style>
<style>
    #productLog .search-box .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #productLog .search-box .el-form-item{
        width: 100% !important;
        margin-bottom: 11px !important;
    }
    #productLog .search-box .el-button{
        padding: 9px 20px !important;
    }
    #productLog .search-box .el-form-item__label{
        padding: 0 !important;
        color: #2f3a4e !important;
        line-height: 14px !important;
        margin-top: 10px;
        margin-bottom: 5px;
    }
    #productLog .search-box .el-form-item__content{
        line-height: 34px !important;
    }
    #productLog .search .el-icon-search{
        line-height: 34px !important;
    }
    #productLog .search-box .el-form-item.m-b-10 {
        margin-bottom: 10px !important;
    }
    #productLog .search-box .el-input__icon{
        line-height: 34px !important;
    }
    #productLog .search .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px !important;
    }
    #productLog .time .el-input__inner{
        line-height: 34px !important;
        height: 34px !important;
        padding: 0 10px 0 25px!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/PlatformLog/productLog.vue